import React from "react";
import AttendanceCell from "./AttendanceCell";
import {
	formatClockTime,
	resolveAttendanceStatusLabel,
} from "./attendanceHelpers";

const AttendancePersonCard = ({ employee, cell, statusLabel, onCellClick }) => {
	const meta = statusLabel
		? { text: statusLabel }
		: resolveAttendanceStatusLabel(cell);
	const clock = formatClockTime(cell?.clock_time);

	return (
		<div className="attendance-person-card">
			<div className="attendance-person-card__status">
				<AttendanceCell
					cell={cell}
					onClick={
						onCellClick
							? () => onCellClick(employee, cell)
							: undefined
					}
				/>
				<span>{meta.text}</span>
			</div>
			<div className="attendance-person-card__time">{clock || "\u00a0"}</div>
			<div className="attendance-person-card__name">{employee.name}</div>
			<div className="attendance-person-card__code">
				{employee.attendance_code || ""}
			</div>
		</div>
	);
};

export default AttendancePersonCard;
